import React from 'react';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';
import styles from './styles.module.scss';

interface IProps {
  text: string,
}

const FeatureItem = ({ text }: IProps) => (
  <div className={ styles.featureItem }>
    <IconCheck
      className={ styles.icon }
    />
    <div className={ styles.text }>{ text }</div>
  </div>
);

export default FeatureItem;
